const translations = {
  pl: {
    appTitle: 'Ekoenergetyka Charging Station Configurator',

    selectChargerModel: 'Wybierz model ładowarki',
    chargerType: 'Typ ładowarki',
    maxPowerKw: 'Moc maks. [kW]',
    meter: 'Licznik',
    terminal: 'Terminal',
    currency: 'Waluta',
    lekoVersion: 'Wersja LEKO',
    templateName: 'Nazwa szablonu',
    description: 'Opis',

    fireExtinguisher: 'Gaśnica',
    coolingSystem: 'System chłodzenia',

    eichrecht: 'Eichrecht',
    factoryReset: 'Factory reset',
    serialization: 'Serializacja',

    model: 'Model',
    product: 'Product',
    serial: 'Serial',

    addSatellites: 'Dodaj satelity',
    addConnectors: 'Dodaj złącza',
    addConnectorsMinTwoCcs: 'Dodaj złącza (minimum 2x CCS)',

    satelliteType: 'Typ satelity',
    connectorType: 'Typ złącza',
    terminalType: 'Typ terminala',

    maxCurrentA: 'Prąd maks. [A]',
    connectorMaxPowerKw: 'Moc maks. złącza [kW]',
    connectorMaxCurrentA: 'Prąd maks. złącza [A]',

	maxCurrentSide1A: 'Prąd maks. side 1 [A]',
	maxCurrentSide2A: 'Prąd maks. side 2 [A]',
	maxCurrentSide3A: 'Prąd maks. side 3 [A]',

	ledController: 'Kontroler LED',

    ccsConnectorPosition: 'Pozycja złącza CCS',
    left: 'Lewe',
    right: 'Prawe',

    generate: 'Generuj!',
    downloadConfig: 'Pobierz konfigurację',
    commitToGitLab: 'Commituj do GitLab',
    downloadFromMegatool: 'Pobierz z Megatoola',

	fileWillBeSavedAsTemplate: 'Plik zostanie zapisany jako szablon',
	fileWillBeDeletedInTenMinutes: 'Plik zostanie usunięty po 10 minutach',

	infoConfigSent: 'Konfiguracja wysłana',
    loading: 'Ładowanie...',
    retry: 'Spróbuj ponownie',
	errorSending: 'Błąd wysyłania',
    errorDownload: 'Błąd pobierania pliku',
	errorBackendCommunication: 'Błąd komunikacji z backendem',
	errorTemplateNameRequired: 'Podaj nazwę szablonu',
	errorAddAtLeastOneSatellite: 'Dodaj przynajmniej jedną satelitę',
	errorAddAtLeastOneConnector: 'Dodaj przynajmniej jedno złącze',
    errorAxonEasyDlbsNeedsTwoCcs: 'Axon Easy DLBS musi mieć co najmniej 2 złącza CCS',
    errorAxonEasyUsesConnectors: 'Axon Easy używa złączy zamiast satelit',
    errorMaxSixOutputs: 'Maksymalnie 6 wyjść',
    errorMaxThreeConnectors: 'Maksymalnie 3 złącza',
    errorMaxDcConnectors: 'Maksymalnie 2 złącza DC',
    errorMaxAcConnectors: 'Maksymalnie 1 złącze AC',
    errorAcOnlyWithTwoCcs: 'AC można dodać tylko po dwóch złączach CCS',
    errorAcOnlyThirdConnector: 'Złącze AC musi być trzecim złączem',
	errorMaxPowerCannotExceed: 'Moc maksymalna nie może być większa niż',
	errorConnectorPowerCannotExceedStationPower: 'Moc maksymalna złącza nie może być większa niż moc maksymalna całej ładowarki',
    infoRemovedInvalidAcConnector: 'Usunięto złącze AC, ponieważ po zmianie układ złączy był nieprawidłowy',
	infoSentToGitLab: 'Wysłano do GitLab',
    infoTemplateAlreadyExists: 'Szablon już istnieje:',
	errorCommit: 'Błąd commitowania',
	infoSwuDownloaded: 'Plik SWU został pobrany',
    missingName: 'brak nazwy',
    templateAlreadyExistsInRepo: 'Szablon istnieje już w repozytorium:',
    downloadExistingSwuHint: 'Możesz pobrać istniejący plik SWU z Megatoola.',


    loadingCommitToGitLab: 'Wysyłanie do GitLab...',
    loadingSwuFromMegatool: 'Pobieranie SWU z Megatoola...',
    megatoolStageStarting: 'Uruchamianie generowania SWU w Megatoolu...',
    megatoolStagePreparing: 'Przygotowywanie paczki w Megatoolu...',
    megatoolStage_queued: 'Oczekiwanie na start generowania SWU...',
    megatoolStage_preparing_payload: 'Pobieranie recepty z Megatoola...',
    megatoolStage_generating_package: 'Megatool generuje paczkę SWU...',
    megatoolStage_downloading_package: 'Backend pobiera paczkę SWU z Megatoola...',
    megatoolStage_ready: 'Paczka SWU jest gotowa do pobrania...',
    megatoolStageDownloading: 'Pobieranie gotowego pliku SWU...',
    errorMegatoolTimeout: 'Megatool przygotowuje paczkę zbyt długo. Spróbuj ponownie później.',
    frontendVersion: 'Frontend',
    backendVersion: 'Backend',
    sendFeedback: 'Zgłoś feedback / błąd',
    feedbackTitle: 'Zgłoś feedback albo błąd',
    feedbackSubtitle: 'Do zgłoszenia automatycznie dołączymy aktualny stan konfiguratora.',
    feedbackPrompt: 'Opisz krótko co się stało albo co warto poprawić.',
    feedbackContextHint: 'Template, użytkownik i wyklikane ustawienia zostaną dołączone automatycznie.',
    feedbackUser: 'Użytkownik',
    feedbackTemplate: 'Szablon',
    feedbackCharger: 'Ładowarka',
    feedbackSending: 'Wysyłanie...',
    submitFeedback: 'Wyślij zgłoszenie',
    feedbackSent: 'Dzięki, zgłoszenie zapisane.',
    feedbackError: 'Nie udało się zapisać zgłoszenia.',
    cancel: 'Anuluj',
    close: 'Zamknij'
  },

  en: {
    appTitle: 'Ekoenergetyka Charging Station Configurator',

    selectChargerModel: 'Select charger model',
    chargerType: 'Charger type',
    maxPowerKw: 'Max power [kW]',
    meter: 'Meter',
    terminal: 'Terminal',
    currency: 'Currency',
    lekoVersion: 'LEKO version',
    templateName: 'Template name',
    description: 'Description',

    fireExtinguisher: 'Fire extinguisher',
    coolingSystem: 'Cooling system',

    eichrecht: 'Eichrecht',
    factoryReset: 'Factory reset',
    serialization: 'Serialization',

    model: 'Model',
    product: 'Product',
    serial: 'Serial',

    addSatellites: 'Add satellites',
    addConnectors: 'Add connectors',
    addConnectorsMinTwoCcs: 'Add connectors (minimum 2x CCS)',

    satelliteType: 'Satellite type',
    connectorType: 'Connector type',
    terminalType: 'Terminal type',

    maxCurrentA: 'Max current [A]',
    connectorMaxPowerKw: 'Connector max power [kW]',
    connectorMaxCurrentA: 'Connector max current [A]',

	maxCurrentSide1A: 'Max current side 1 [A]',
	maxCurrentSide2A: 'Max current side 2 [A]',
	maxCurrentSide3A: 'Max current side 3 [A]',

	ledController: 'LED controller',

    ccsConnectorPosition: 'CCS connector position',
    left: 'Left',
    right: 'Right',

    generate: 'Generate!',
    downloadConfig: 'Download configuration',
    commitToGitLab: 'Commit to GitLab',
    downloadFromMegatool: 'Download from Megatool',

	fileWillBeSavedAsTemplate: 'File will be saved as template',
	fileWillBeDeletedInTenMinutes: 'File will be deleted in 10 minutes',

	infoConfigSent: 'Configuration sent',
    loading: 'Loading...',
    retry: 'Retry',
	errorSending: 'Error sending',
    errorDownload: 'File download error',
	errorBackendCommunication: 'Backend communication error',
	errorTemplateNameRequired: 'Please provide a template name',
	errorAddAtLeastOneSatellite: 'Add at least one satellite',
	errorAddAtLeastOneConnector: 'Add at least one connector',
    errorAxonEasyDlbsNeedsTwoCcs: 'Axon Easy DLBS must have at least 2 CCS connectors',
    errorAxonEasyUsesConnectors: 'Axon Easy uses connectors instead of satellites',
    errorMaxSixOutputs: 'Maximum 6 outputs',
    errorMaxThreeConnectors: 'Maximum 3 connectors',
    errorMaxDcConnectors: 'Maximum 2 DC connectors',
    errorMaxAcConnectors: 'Maximum 1 AC connector',
    errorAcOnlyWithTwoCcs: 'AC can be added only after two CCS connectors',
    errorAcOnlyThirdConnector: 'AC connector must be the third connector',
	errorMaxPowerCannotExceed: 'Max power cannot exceed',
	errorConnectorPowerCannotExceedStationPower: 'Connector max power cannot exceed station max power',
    infoRemovedInvalidAcConnector: 'Removed AC connector because the connector layout became invalid',
	infoSentToGitLab: 'Sent to GitLab',
    infoTemplateAlreadyExists: 'Template already exists:',
	errorCommit: 'Error committing',
	infoSwuDownloaded: 'SWU file downloaded',
    missingName: 'missing name',
    templateAlreadyExistsInRepo: 'Template already exists in repository:',
    downloadExistingSwuHint: 'You can download the existing SWU file from Megatool.',


    loadingCommitToGitLab: 'Sending to GitLab...',
    loadingSwuFromMegatool: 'Downloading SWU from Megatool...',
    megatoolStageStarting: 'Starting SWU generation in Megatool...',
    megatoolStagePreparing: 'Preparing package in Megatool...',
    megatoolStage_queued: 'Waiting for SWU generation to start...',
    megatoolStage_preparing_payload: 'Fetching recipe from Megatool...',
    megatoolStage_generating_package: 'Megatool is generating the SWU package...',
    megatoolStage_downloading_package: 'Backend is downloading the SWU package from Megatool...',
    megatoolStage_ready: 'SWU package is ready to download...',
    megatoolStageDownloading: 'Downloading the ready SWU file...',
    errorMegatoolTimeout: 'Megatool is taking too long to prepare the package. Try again later.',
    frontendVersion: 'Frontend',
    backendVersion: 'Backend',
    sendFeedback: 'Send feedback / bug',
    feedbackTitle: 'Send feedback or bug',
    feedbackSubtitle: 'The current configurator state will be attached automatically.',
    feedbackPrompt: 'Briefly describe what happened or what should be improved.',
    feedbackContextHint: 'Template, user and selected settings will be attached automatically.',
    feedbackUser: 'User',
    feedbackTemplate: 'Template',
    feedbackCharger: 'Charger',
    feedbackSending: 'Sending...',
    submitFeedback: 'Send report',
    feedbackSent: 'Thanks, the report was saved.',
    feedbackError: 'Could not save feedback.',
    cancel: 'Cancel',
    close: 'Close'
  }
};

export default translations;
